
// export const domain = "http://192.168.18.101:9013"

// https://panchayatirajbalarampur.com/

export const domain = "https://panchayatirajbalarampur.org"
export const front_end_domain = "https://panchayatirajbalarampur.org"



export const API_URLS = {

  master_login: `${domain}/api/v1/master-login`,

  create_district: `${domain}/api/v1/create-district`,
  get_district_master: `${domain}/api/v1/get-district`,
  update_district: `${domain}/api/v1/update-district`,
  update_district_status: `${domain}/api/v1/update-district-status`,
  district_master_excel: `${domain}/api/v1/district-master-excel`,

  create_designation: `${domain}/api/v1/create-designation`,
  get_designation_master: `${domain}/api/v1/get-designation`,
  update_designation: `${domain}/api/v1/update-designation`,
  update_designation_status: `${domain}/api/v1/update-designation-status`,
  designation_master_excel: `${domain}/api/v1/designation-master-excel`,

  create_zone_manager: `${domain}/api/v1/create-zone-manager`,
  get_zone_manager: `${domain}/api/v1/get-zone-manager`,
  update_zone_manager: `${domain}/api/v1/update-zone-manager`,
  update_master_login_status: `${domain}/api/v1/update-master-login-status`,
  zone_manager_excel: `${domain}/api/v1/zone-manager-excel`,


  create_zone_master: `${domain}/api/v1/create-zone-master`,
  get_zone_master: `${domain}/api/v1/get-zone-master`,
  update_zone_master: `${domain}/api/v1/update-zone-master`,
  update_zone_status: `${domain}/api/v1/update-zone-status`,
  get_zone_excel: `${domain}/api/v1/get-zone-excel`,


  create_village_master: `${domain}/api/v1/create-village-master`,
  get_village_master: `${domain}/api/v1/get-village-master`,
  update_village_master: `${domain}/api/v1/update-village-master`,
  village_master_status: `${domain}/api/v1/village-master-status`,
  get_village_excel: `${domain}/api/v1/get-village-master-excel`,


  create_qualification: `${domain}/api/v1/create-qualificatoin`,
  get_qualification_master: `${domain}/api/v1/get-qualificatoin`,
  update_qualification: `${domain}/api/v1/update-qualificatoin`,
  update_qualification_status: `${domain}/api/v1/update-qualificatoin-status`,
  qualificatoin_status_excel: `${domain}/api/v1/qualificatoin-status-excel`,

  create_grade: `${domain}/api/v1/create-grade`,
  get_grade_master: `${domain}/api/v1/get-grade`,
  update_grade: `${domain}/api/v1/update-grade`,
  update_grade_status: `${domain}/api/v1/update-grade-status`,
  grade_status_excel: `${domain}/api/v1/grade-status-excel`,

  create_leave: `${domain}/api/v1/create-leave-type`,
  get_leave: `${domain}/api/v1/get-leave-type`,
  update_leave: `${domain}/api/v1/update-leave-type`,
  status_leave: `${domain}/api/v1/update-leave-type-status`,
  excel_leave: `${domain}/api/v1/leave-type-status-excel`,

  create_holiday_type: `${domain}/api/v1/create-holiday-type`,
  get_holiday_type: `${domain}/api/v1/get-holiday-type`,
  update_holiday_type: `${domain}/api/v1/update-holiday-type`,
  status_holiday_type: `${domain}/api/v1/update-holiday-type-status`,
  excel_holiday_type: `${domain}/api/v1/holiday-type-status-excel`,

  create_shift: `${domain}/api/v1/create-shift`,
  get_shift: `${domain}/api/v1/get-shift`,
  update_shift: `${domain}/api/v1/update-shift`,
  status_shift: `${domain}/api/v1/update-shift-status`,
  shift_excel: `${domain}/api/v1/shift-status-excel`,

  create_emp_registration: `${domain}/api/v1/emp-registration`,
  update_emp_profile_update_by_admin: `${domain}/api/v1/emp-profile-update-by-admin`,
  emp_profile_update_status: `${domain}/api/v1/emp-profile-update-status`,
  get_emp_report: `${domain}/api/v1/emp-employee-report`,
  excel_emp_report: `${domain}/api/v1/emp-employee-report-excel`,

  get_bank: `${domain}/api/v1/get-bank`,
  

  get_attendance_report: `${domain}/api/v1/emp-attendance-report`,
  excel_attendance_report: `${domain}/api/v1/emp-attendance-report-excel`,

  send_notification_by_admin: `${domain}/api/v1/sent-notification-by-admin`,

  get_emp_leave_report: `${domain}/api/v1/emp-leave-report`,
  status_emp_leave_report: `${domain}/api/v1/emp-leave-report-status-update`,
  excel_emp_leave_report: `${domain}/api/v1/emp-leave-report-excel`,

  master_dashboard: `${domain}/api/v1/master-dashboard`,
  
  emp_dashboard_report: `${domain}/api/v1/emp-dashboard`,

  master_main_dashboard: `${domain}/api/v1/master-main-dashboard`,

 
};
